const CropQuery = (id) => {
  return `
    query {
        getCropById(id: "${id}") {
          id
          group_id,
          form_id,
          CropFormData {
            new_profile_crop_crop_id
            new_profile_crop_crop_work_state
            new_profile_crop_crop_agricultural_activity
            new_profile_crop_per
            new_profile_crop_wage_offer
            new_profile_crop_piece_rate_offer
            new_profile_crop_piece_rate_units
            new_profile_crop_profile_name
          }
        }
      }
      `;
};

export const CropsQuery = (id) => {
  return `
    query {
        getCropByIds(ids: ${id}) {
          id
          group_id,
          form_id,
          CropFormData {
            new_profile_crop_crop_id
            new_profile_crop_crop_work_state
            new_profile_crop_crop_agricultural_activity
            new_profile_crop_per
            new_profile_crop_wage_offer
            new_profile_crop_piece_rate_offer
            new_profile_crop_piece_rate_units
            new_profile_crop_profile_name
          }
        }
      }
      `;
};

export default CropQuery;
